<template>
  <div class="vue_body_min_height" style="padding-bottom: 50px;">
    <img v-if="currentBanner != null" :src="currentBanner.url" style="width: 100%;">
    <div class="container" style="text-align: center;" v-if="tabList.length > 0">

      <div v-if="item != null" id="detail_top_title">{{item.title}}</div>
      <div v-if="item != null" id="detail_top_desc">{{item.subtitle}}</div>

      <div v-if="tabList.length > 1" class="row" id="detail_top_menu" >
        <div v-for="(item, index) in tabList" >
          <a  href="javascript:void(null);"
              @click="menuClicked(index)"
              :class="[tabIndex == index ? 'active' : '']">{{item.title}}</a>
        </div>
      </div>

<!--      <match-detail-scedule v-if="tabIndex == 0" />-->
<!--      <match-detail-teams v-else-if="tabIndex == 1" />-->
<!--      <match-detail-news v-else />-->
      <match-detail-news v-if="item != null && tabList[tabIndex].src == 'activity'" v-bind:tagName="item.title" />
      <div v-else id="href_iframe_outer">
        <iframe id="href_iframe"
                frameborder="0"
                border="0"
                marginwidth="0"
                marginheight="0"
                scrolling="auto"
                allowtransparency="yes"
                v-on:load="iFrameLoaded"
                :src="tabList[tabIndex].src"></iframe>
      </div>
    </div>

    <login-dialog v-if="showLogin" v-on:close="closeLoginDialog"></login-dialog>

  </div>
</template>

<script>
import MatchItemCard from "../components/matches/MatchItemCard";
import BottomPaginator from "../components/BottomPaginator";
import MatchDetailScedule from "../components/matches/MatchDetailScedule";
import MatchDetailTeams from "../components/matches/MatchDetailTeams";
import MatchDetailNews from "../components/matches/MatchDetailNews";

import LoginDialog from "../components/common/LoginDialog";

export default {
  name: "MatchDetailPage",
  components: {
    MatchItemCard,
    BottomPaginator,
    MatchDetailScedule,
    MatchDetailTeams,
    MatchDetailNews,
    LoginDialog

  },
  data() {
    return {
      tabList: [],
      item: null,
      tabIndex: 0,

      intervalFlag: null,
      checkFlag: null,
      secondValue: 20,
      showLogin: false,
      isiframeLoaded: false,
      isLogined: true,

      addActivities: false,
    }
  },
  computed: {
    dataManager() {
      return this.$store.state.dataStore;
    },

    md() {
      let md = this.$route.query.md;
      return md != undefined ? md : null;
    },

    dataLoadManager() {
      if (this.md == null) {
        return this.$store.state.http.ajax.vmMatchGet;
      } else {
        this.$store.state.http.ajax.mdGet;
      }
    },

    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'matches';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },
    matchId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    if (this.matchId != undefined) {
      this.loadData();
    }
    window.onresize = this.changeFrameHeight;

    let query = this.$route.query;
    let code = query.code;
    let state = query.state;

    if (state != undefined) {
      this.showLogin = true;
      return;
    }
    this.checkNeedsLogin();
  },
  destroyed() {
    if (this.intervalFlag != null) {
      clearTimeout(this.intervalFlag);
      this.intervalFlag = null;
    }

    if (this.checkFlag != null) {
      clearTimeout(this.checkFlag);
      this.checkFlag = null;
    }
  },
  methods: {
    menuClicked(index) {
      this.tabIndex = index;
      setTimeout(this.changeFrameHeight(), 2000);
    },
    loadData() {
      let _this = this;
      let success = function (data) {
        if (data.code == 0) {
          _this.item = data.data;
          // _this.dealWithTabs();
          _this.loadActivitiesData();
          _this.dealWithShareObj();
        } else {
          _this.$toast('请求失败！');
        }
      };

      let failure = function (data) {

      };

      if (this.md == null) {
        this.$store.state.http.ajax.vmMatchGet(this.matchId, success, failure);
      } else {
        this.$store.state.http.ajax.mdGet(this.matchId, success, failure);
      }
    },

    checkNeedsLogin() {
      let _this = this;
      this.checkToken(this.$store,function (data) {
        let code = data.code;
        _this.isLogined = code == 0;
        _this.dealWithInterval();
        // if (code == 0) { // 开启定时，监测
          // _this.checkFlag = setTimeout(_this.checkNeedsLogin, 20 * 60 * 1000);
        // } else {
        //   _this.checkFlag = null;
        // }
      });
    },

    dealWithShareObj() {
      let shareObj = this.$store.state.http.defaultShareObj;
      shareObj.title = this.item.title;
      shareObj.link = location.href;
      this.configShareWx(encodeURIComponent(location.href), shareObj);
    },

    loadActivitiesData() {
      if (this.item == null) {
        return;
      }
      let tag = ((this.item.title == undefined || this.item.title == null) ? '' : this.item.title).removeBlanks();
      let params = {
        pageIndex: 1,
        size: 10,
        tag: tag,
      };
      let _this = this;
      this.$store.state.http.ajax.matchDeatilList(params,function (data) {
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          if (newList.length > 0) {
            _this.addActivities = true;
          }
          _this.dealWithTabs();
          return;
        }
        _this.dealWithTabs();
      },function (data) {
        _this.dealWithTabs();
      });
    },

    dealWithTabs() {
      let item = this.item;
      if (item == null) {
        return;
      }
      let list = [];

      let scheduleUrl = item.scheduleUrl;
      if (scheduleUrl != null && scheduleUrl.length > 0) {
        let obj1 = {
          title: '赛程表',
          src: item.scheduleUrl
        };
        list.push(obj1);
      }

      let leagueUrl = item.leagueUrl;
      if (leagueUrl != null && leagueUrl.length > 0) {
        let obj2 = {
          title: '积分榜',
          src: item.leagueUrl
        };
        list.push(obj2);
      }

      let playerUrl = item.playerUrl;
      if (playerUrl != null && playerUrl.length > 0) {
        let obj3 = {
          title: '球员榜',
          src: item.playerUrl
        };
        list.push(obj3);
      }

      if (this.addActivities) {
        let obj4 = {
          title: '动态',
          src: 'activity'
        };
        list.push(obj4);
      }

      let eventUrl = item.eventUrl;
      if (eventUrl != null && eventUrl.length > 0) {
        let obj5 = {
          title: '赛事信息',
          src: item.eventUrl
        };
        list.push(obj5);
      }
      this.tabList = list;
    },

    subTitle(item) {

    },

    iFrameLoaded() {
      this.isiframeLoaded = true;
      this.changeFrameHeight();
      this.dealWithInterval();
    },

    dealWithInterval() {
      if (!this.isLogined && this.isiframeLoaded) {
        let timerInterval = this.secondValue * 1000;
        this.intervalFlag = setTimeout(this.showLoginPage, timerInterval);
      }
    },

    showLoginPage() {
      let showed = this.$store.state.dataStore.showLoginDialog();
      if (!showed) {
        this.intervalFlag = null;
        return;
      }
      this.showLogin = true;
      this.intervalFlag = null;
    },

    closeLoginDialog() {
      let token = this.dataManager.getToken();
      if (token != null) {
        this.isLogined = true;
        // this.checkFlag = setTimeout(this.checkNeedsLogin, 20 * 60 * 1000);
      }
      this.showLogin = false;
      // this.dealWithInterval();
    },

    changeFrameHeight() {
      let iframe = document.getElementById('href_iframe');
      if (iframe != undefined && iframe != null) {
        iframe.height = document.documentElement.clientHeight - 4;
      }
    }
  }
}
</script>

<style scoped>

  #detail_top_title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-top: 40px;
  }

  #detail_top_desc {
    font-size: 1rem;
    color: #999;
    margin-top: 10px;
  }

  #detail_top_menu {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  #detail_top_menu a {
    text-decoration: none;
    color: #333;
    font-weight: bold;
  }

  #detail_top_menu > div {
    margin-top: 20px;
  }

  #detail_top_menu a.active {
    color: #fc1a34;
    pointer-events: none;
   }

  #href_iframe_outer {
    margin-top: 30px;
    padding: 0;
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  #href_iframe {
    width: 100%;
    padding: 0;
    margin-top: auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/MatchDetailPage.vue